<template>
    <div class="m-1">

        <!-- Alert: No item found -->
        <b-alert
                variant="danger"
                :show="currencyData === undefined"
        >
            <h4 class="alert-heading">
                Error fetching user data
            </h4>
            <div class="alert-body p-3">
                No user found with this user id. Check
                <b-link
                        class="alert-link"
                        :to="{ name: 'apps-users-list'}"
                >
                    User List
                </b-link>
                for other users.
            </div>
        </b-alert>

        <div v-if="currencyData === null" class="mt-4 d-flex align-items-center justify-content-center">
            <b-spinner class=""></b-spinner>
        </div>

        <template v-if="currencyData">
            <!-- First Row -->
            <b-row>
                <b-col
                        cols="12"
                        xl="12"
                        lg="12"
                        md="12"
                >
                    <currency-view-currency-info-card :currency-data="currencyData" />
                </b-col>
            </b-row>

            <b-row>
                <b-col
                        cols="12"
                        lg="12"
                >
                    <!-- <user-view-user-permissions-card /> -->
                </b-col>
            </b-row>

        </template>

    </div>
</template>

<script>
  import { BAlert, BCol, BLink, BRow, BSpinner } from 'bootstrap-vue'
  // import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
  import CurrencyViewCurrencyInfoCard from './CurrencyViewCurrencyInfoCard.vue'
  import { mapActions } from 'vuex'

  export default {
    components: {
      BRow,
      BCol,
      BAlert,
      BLink,
      BSpinner,
      // Local Components
      CurrencyViewCurrencyInfoCard,
      // InvoiceList,
    },

    data(){
      return{
        currencyData : null
      }
    },
    methods: {
      ...mapActions('currency', ['show']),
    },
    async mounted() {
      const show = await this.show(this.$router.currentRoute.params.id)
      if (show)
        this.currencyData= show.currency
    }
  }
</script>

<style>

</style>
